import { render, staticRenderFns } from "./AddLightCourseModuleModal.vue?vue&type=template&id=28567040&"
import script from "./AddLightCourseModuleModal.vue?vue&type=script&lang=js&"
export * from "./AddLightCourseModuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports